import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import {SanitizeHtml} from "./app.pipe"; 
import { UniquePipe } from './unique.pipe';

@NgModule({
    declarations: [SanitizeHtml,UniquePipe], 
  imports:[CommonModule],
    exports: [SanitizeHtml, UniquePipe]
})

export class MainPipe{}